
<el-container class="screen-parameters screen-parameters-fullHeight services" v-loading="loading || loadingDelete">
  <div class="clients-panel cash-list">
    <div class="clients-panel-container">
      <el-row class="black-inputs">
        <div class="cash-header">
          <div class="nav-toggle" @click="showHideScreenEvents">
            <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
          </div>
          <div class="screen-title">Évènements</div>
        </div>
        <el-row>
          <el-col :md="{ span: 4, offset: 10 }" :xs="24" :sm="{ span: 12, offset: 12 }">
            <el-button type="primary" @click="editEventInfos(null, null, null)">Créer un évènement</el-button>
          </el-col>
        </el-row>
      </el-row>
      <el-row class="black-inputs">
        <el-col :md="24" class="screen-clients">
          <el-table ref="multipleTable" :data="getEventsList">
            <el-table-column prop="name" label="Nom" sortable>
            </el-table-column>
            <el-table-column prop="title" label="Titre" sortable>
            </el-table-column>
            <el-table-column prop="startDate" label="Début" sortable>
              <template slot-scope="scope">
                <span>{{ dateRenderer(scope.row.startDate) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="endDate" label="Fin" sortable>
              <template slot-scope="scope">
                <span>{{ dateRenderer(scope.row.endDate) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="Type" sortable>
              <template slot-scope="scope">
                <span v-if="strUcFirst(scope.row.type) !== 'N'">{{ strUcFirst(scope.row.type) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="days" label="Jours" sortable>
              <template slot-scope="scope">
                <span v-if="getDaysIsVisible(scope.row)">{{ scope.row.days.join(', ') }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label=" " width="70">
              <template slot-scope="scope">
                <el-popover placement="top" v-model="scope.row.popupLinkEvent"
                  popper-class="popup-delete black-inputs">
                  <p>
                    <el-col v-if="getLink(scope.row) !== ''" :span="24" @click="copylink(scope.row)"
                      class="screen-fake-input">
                      <span @click="copylink(scope.row)" id="link">{{ getLink(scope.row) }}</span>
                      <i @click="copylink(scope.row)" style="padding-left: 10px; cursor:pointer"
                        class="el-icon-document-copy"></i>
                    </el-col>
                  </p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" class="dark" type="primary"
                      @click="scope.row.popupLinkEvent = false">Fermer</el-button>
                    <!-- <el-button type="primary" size="mini" @click="deleteEvent(scope.row)">Confirmer</el-button> -->
                  </div>
                  <el-button style="width: auto" round class="dark" type="primary" slot="reference">
                    <span><i class="el-icon-link"></i></span>
                  </el-button>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label=" ">
              <template slot-scope="scope">
                <el-button class="dark" type="primary" @click="editEventInfos(scope.row)">
                  <span class="mobile-show"><i class="el-icon-edit"></i></span>
                  <span class="mobile-hide">Modifier</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label=" ">
              <template slot-scope="scope">
                <el-popover placement="right" width="200" trigger="manual" v-model="scope.row.popupValidDelete"
                  popper-class="popup-delete black-inputs">
                  <p>Si vous voulez supprimer ce service, merci d'indiquer votre mot de passe</p>
                  <el-input v-model="checkPassValue" type="password"></el-input>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" class="dark" type="primary"
                      @click="scope.row.popupValidDelete = false">Annuler</el-button>
                    <el-button type="primary" size="mini" @click="deleteEvent(scope.row)">Confirmer</el-button>
                  </div>
                  <el-button slot="reference" @click="scope.row.popupValidDelete = !scope.row.popupValidDelete"
                    class="red">
                    Supprimer
                  </el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;margin-top: 30px;">
            <el-pagination background layout="prev, pager, next" :total="total" @current-change="current_change">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</el-container>
